<template>
    <div class="container">
      <div class="row">
        <div class="col-sm-12">
          <h4>物流拋單</h4>
        </div>
        <div class="col-sm-12">
          <el-input
            placeholder="Please input order ID"
            type="text"
            v-model="orderId"
            @keyup.enter.native="logisticRecall(orderId)"
          >
            <el-button
              ref="template-search"
              slot="append"
              icon="el-icon-search"
              @click.native="logisticRecall(orderId)"
              :disabled="callLogisticDisable"
            ></el-button>
          </el-input>
        </div>
        <div class="col-sm-12">
          <span class="text-red">{{ logisticRecallRes }}</span>
        </div>
      </div>
      <hr />
    </div>
</template>

<script>
export default {
  data() {
    return {
      orderId: "",
      logisticRecallRes: "",
      callLogisticDisable: false
    };
  },
  methods: {
    logisticRecall(orderId) {
      let that = this;
      this.callLogisticDisable = true;
      this.$message({
        type: "info",
        message: "物流請求已送出"
      });
      createLogisticOrder(orderId)
        .then(createLogisticOrderRes => {
          that.logisticRecallRes = createLogisticOrderRes.data;
          that.orderId = "";
          that.callLogisticDisable = false;
        })
        .catch(createLogisticOrderErr => {
          that.logisticRecallRes = createLogisticOrderErr;
          that.callLogisticDisable = false;
        });
    }
  }
};
</script>
